import styled from "styled-components";

export const StatusWrapper = styled.div`
  position: relative;
  display: inline-block;

  .ant-badge {
    .ant-badge-status-dot {
      width: 10px;
      height: 10px;
      border: 2px solid var(--white);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }

    .ant-badge-status-error {
      background-color: var(--color-danger);
    }

    .ant-badge-status-warning {
      background-color: var(--orange);
    }

    .ant-badge-status-processing {
      position: absolute;
      background-color: var(--color-primary);
    }
  }
`;
